/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HTTPValidationError,
  OrganizationMemberRead,
  OrganizationUserRead,
  PasswordReset,
  UserCreate,
  UserCreateResponse,
  UserImportRequest,
  UserImportResponse,
  UserMetricsRead,
  UserOrganization,
  UserRead,
  UserSearchRead,
  UserUpdate,
} from '../models/index';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    OrganizationMemberReadFromJSON,
    OrganizationMemberReadToJSON,
    OrganizationUserReadFromJSON,
    OrganizationUserReadToJSON,
    PasswordResetFromJSON,
    PasswordResetToJSON,
    UserCreateFromJSON,
    UserCreateToJSON,
    UserCreateResponseFromJSON,
    UserCreateResponseToJSON,
    UserImportRequestFromJSON,
    UserImportRequestToJSON,
    UserImportResponseFromJSON,
    UserImportResponseToJSON,
    UserMetricsReadFromJSON,
    UserMetricsReadToJSON,
    UserOrganizationFromJSON,
    UserOrganizationToJSON,
    UserReadFromJSON,
    UserReadToJSON,
    UserSearchReadFromJSON,
    UserSearchReadToJSON,
    UserUpdateFromJSON,
    UserUpdateToJSON,
} from '../models/index';

export interface GetAllUsersRequest {
    membershipActive?: boolean | null;
    xOrganizationID?: string | null;
}

export interface GetUserMetricsRequest {
    xOrganizationID?: string | null;
}

export interface ListOrganizationMembersRequest {
    search?: string | null;
    grade?: number | null;
    limit?: number;
    staffOnly?: boolean;
    xOrganizationID?: string | null;
}

export interface OrgActivateMemberRequest {
    userId: string;
    xOrganizationID?: string | null;
}

export interface OrgCreateUserRequest {
    userCreate: UserCreate;
    xOrganizationID?: string | null;
}

export interface OrgDeactivateMemberRequest {
    userId: string;
    xOrganizationID?: string | null;
}

export interface OrgImportUsersRequest {
    userImportRequest: UserImportRequest;
    xOrganizationID?: string | null;
}

export interface OrgRemoveMemberRequest {
    userId: string;
    xOrganizationID?: string | null;
}

export interface OrgResetUserPasswordRequest {
    userId: string;
    xOrganizationID?: string | null;
    passwordReset?: PasswordReset;
}

export interface OrgUpdateUserRequest {
    userId: string;
    userUpdate: UserUpdate;
    xOrganizationID?: string | null;
}

export interface SearchUsersRequest {
    search: string;
    limit?: number;
}

/**
 * 
 */
export class UsersApi extends runtime.BaseAPI {

    /**
     * Return every user with a role in the current organization, with their membership status.  `membership_active` is the status in this organization (deactivated members are listed, so they can be reactivated; removed members are not); `is_active` is the account status, which only a superadmin changes. `role_ids` are the user\'s roles here, active or not.  Organization context is determined by X-Organization-ID header or user\'s first active org. User must be an administrator in the organization to access this endpoint.
     * Get All Users
     */
    async getAllUsersRaw(requestParameters: GetAllUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OrganizationUserRead>>> {
        const queryParameters: any = {};

        if (requestParameters['membershipActive'] != null) {
            queryParameters['membership_active'] = requestParameters['membershipActive'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OrganizationUserReadFromJSON));
    }

    /**
     * Return every user with a role in the current organization, with their membership status.  `membership_active` is the status in this organization (deactivated members are listed, so they can be reactivated; removed members are not); `is_active` is the account status, which only a superadmin changes. `role_ids` are the user\'s roles here, active or not.  Organization context is determined by X-Organization-ID header or user\'s first active org. User must be an administrator in the organization to access this endpoint.
     * Get All Users
     */
    async getAllUsers(requestParameters: GetAllUsersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OrganizationUserRead>> {
        const response = await this.getAllUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return all organizations the current user is a member of, with their roles.
     * Get Current User Organizations
     */
    async getCurrentUserOrganizationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserOrganization>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/me/organizations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserOrganizationFromJSON));
    }

    /**
     * Return all organizations the current user is a member of, with their roles.
     * Get Current User Organizations
     */
    async getCurrentUserOrganizations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserOrganization>> {
        const response = await this.getCurrentUserOrganizationsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Return the profile of the currently authenticated user.
     * Get Current User Profile
     */
    async getCurrentUserProfileRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserRead>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserReadFromJSON(jsonValue));
    }

    /**
     * Return the profile of the currently authenticated user.
     * Get Current User Profile
     */
    async getCurrentUserProfile(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserRead> {
        const response = await this.getCurrentUserProfileRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get user metrics for dashboard (total, active, by role, by grade).  Organization context is determined by X-Organization-ID header or user\'s first active org. User must be an administrator in the organization to access this endpoint.
     * Get User Metrics
     */
    async getUserMetricsRaw(requestParameters: GetUserMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserMetricsRead>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/metrics`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserMetricsReadFromJSON(jsonValue));
    }

    /**
     * Get user metrics for dashboard (total, active, by role, by grade).  Organization context is determined by X-Organization-ID header or user\'s first active org. User must be an administrator in the organization to access this endpoint.
     * Get User Metrics
     */
    async getUserMetrics(requestParameters: GetUserMetricsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserMetricsRead> {
        const response = await this.getUserMetricsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Look up the active members of the current organization. Staff of the organization.  Returns id, username, names, grade and the member\'s role ids in the organization, ordered by last name, first name, username. `search` and `grade` narrow the result on the server; `staff_only` keeps the staff (administrator, content creator, competition organizer, superadmin role) and the owner, for mentor pickers; `limit` caps it. Meant for member pickers (mentor, participants, class members).
     * List Organization Members
     */
    async listOrganizationMembersRaw(requestParameters: ListOrganizationMembersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OrganizationMemberRead>>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['grade'] != null) {
            queryParameters['grade'] = requestParameters['grade'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['staffOnly'] != null) {
            queryParameters['staff_only'] = requestParameters['staffOnly'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/members`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OrganizationMemberReadFromJSON));
    }

    /**
     * Look up the active members of the current organization. Staff of the organization.  Returns id, username, names, grade and the member\'s role ids in the organization, ordered by last name, first name, username. `search` and `grade` narrow the result on the server; `staff_only` keeps the staff (administrator, content creator, competition organizer, superadmin role) and the owner, for mentor pickers; `limit` caps it. Meant for member pickers (mentor, participants, class members).
     * List Organization Members
     */
    async listOrganizationMembers(requestParameters: ListOrganizationMembersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OrganizationMemberRead>> {
        const response = await this.listOrganizationMembersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reactivate a member in the current organization.  Sets the member\'s role rows in this organization active again, except superadmin rows. Administrators of the organization only. 400 for a user whose only role here is superadmin; 404 for a user who is not a member of the organization.
     * Org Activate Member
     */
    async orgActivateMemberRaw(requestParameters: OrgActivateMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationUserRead>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling orgActivateMember().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/{user_id}/activate`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationUserReadFromJSON(jsonValue));
    }

    /**
     * Reactivate a member in the current organization.  Sets the member\'s role rows in this organization active again, except superadmin rows. Administrators of the organization only. 400 for a user whose only role here is superadmin; 404 for a user who is not a member of the organization.
     * Org Activate Member
     */
    async orgActivateMember(requestParameters: OrgActivateMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationUserRead> {
        const response = await this.orgActivateMemberRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new user with the provided username, password, and role_ids.  Organization context is determined by X-Organization-ID header or user\'s first active org. User must be an administrator in the organization to create users.
     * Org Create User
     */
    async orgCreateUserRaw(requestParameters: OrgCreateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserCreateResponse>> {
        if (requestParameters['userCreate'] == null) {
            throw new runtime.RequiredError(
                'userCreate',
                'Required parameter "userCreate" was null or undefined when calling orgCreateUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserCreateToJSON(requestParameters['userCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserCreateResponseFromJSON(jsonValue));
    }

    /**
     * Create a new user with the provided username, password, and role_ids.  Organization context is determined by X-Organization-ID header or user\'s first active org. User must be an administrator in the organization to create users.
     * Org Create User
     */
    async orgCreateUser(requestParameters: OrgCreateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserCreateResponse> {
        const response = await this.orgCreateUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deactivate a member in the current organization (temporary).  Sets the member\'s role rows in this organization inactive, except superadmin rows: the member loses access to this organization and keeps their account, their sessions, their other organizations and their seat here. Administrators of the organization only. 400 for oneself, the organization\'s owner, or a user whose only role here is superadmin; 404 for a user who is not a member of the organization.
     * Org Deactivate Member
     */
    async orgDeactivateMemberRaw(requestParameters: OrgDeactivateMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationUserRead>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling orgDeactivateMember().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/{user_id}/deactivate`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationUserReadFromJSON(jsonValue));
    }

    /**
     * Deactivate a member in the current organization (temporary).  Sets the member\'s role rows in this organization inactive, except superadmin rows: the member loses access to this organization and keeps their account, their sessions, their other organizations and their seat here. Administrators of the organization only. 400 for oneself, the organization\'s owner, or a user whose only role here is superadmin; 404 for a user who is not a member of the organization.
     * Org Deactivate Member
     */
    async orgDeactivateMember(requestParameters: OrgDeactivateMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationUserRead> {
        const response = await this.orgDeactivateMemberRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Bulk import users with a shared initial password.  Rows with invalid or already-used emails are skipped and reported per row with a reason code; the whole batch is rejected if it exceeds the organization\'s license limit. A row skipped as `email_taken` names the user (`user_id`, `username`) only when they are already an active member of this organization with an active account.  Organization context is determined by X-Organization-ID header or user\'s first active org. User must be an administrator in the organization to import users.
     * Org Import Users
     */
    async orgImportUsersRaw(requestParameters: OrgImportUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserImportResponse>> {
        if (requestParameters['userImportRequest'] == null) {
            throw new runtime.RequiredError(
                'userImportRequest',
                'Required parameter "userImportRequest" was null or undefined when calling orgImportUsers().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/import`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserImportRequestToJSON(requestParameters['userImportRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserImportResponseFromJSON(jsonValue));
    }

    /**
     * Bulk import users with a shared initial password.  Rows with invalid or already-used emails are skipped and reported per row with a reason code; the whole batch is rejected if it exceeds the organization\'s license limit. A row skipped as `email_taken` names the user (`user_id`, `username`) only when they are already an active member of this organization with an active account.  Organization context is determined by X-Organization-ID header or user\'s first active org. User must be an administrator in the organization to import users.
     * Org Import Users
     */
    async orgImportUsers(requestParameters: OrgImportUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserImportResponse> {
        const response = await this.orgImportUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove a member from the current organization (permanent).  Deletes the member\'s role rows in this organization, except superadmin rows, which frees their seat (unless a superadmin row remains). The account, its other organizations and everything the member authored stay; only a superadmin deletes accounts. Administrators of the organization only. 400 for oneself, the organization\'s owner, or a user whose only role here is superadmin; 404 for a user who is not a member of the organization.
     * Org Remove Member
     */
    async orgRemoveMemberRaw(requestParameters: OrgRemoveMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling orgRemoveMember().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/{user_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove a member from the current organization (permanent).  Deletes the member\'s role rows in this organization, except superadmin rows, which frees their seat (unless a superadmin row remains). The account, its other organizations and everything the member authored stay; only a superadmin deletes accounts. Administrators of the organization only. 400 for oneself, the organization\'s owner, or a user whose only role here is superadmin; 404 for a user who is not a member of the organization.
     * Org Remove Member
     */
    async orgRemoveMember(requestParameters: OrgRemoveMemberRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.orgRemoveMemberRaw(requestParameters, initOverrides);
    }

    /**
     * Reset a user\'s password to a custom or temporary password. Admin only.  Organization context is determined by X-Organization-ID header or user\'s first active org. User must be an administrator in the organization to reset passwords.  If password is provided in the request body, it will be set as the new password. Otherwise, a temporary password will be generated. The caller\'s own password answers 400 (use POST /auth/change-password, which asks for the current password).
     * Org Reset User Password
     */
    async orgResetUserPasswordRaw(requestParameters: OrgResetUserPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: string | null; }>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling orgResetUserPassword().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/{user_id}/reset-password`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PasswordResetToJSON(requestParameters['passwordReset']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Reset a user\'s password to a custom or temporary password. Admin only.  Organization context is determined by X-Organization-ID header or user\'s first active org. User must be an administrator in the organization to reset passwords.  If password is provided in the request body, it will be set as the new password. Otherwise, a temporary password will be generated. The caller\'s own password answers 400 (use POST /auth/change-password, which asks for the current password).
     * Org Reset User Password
     */
    async orgResetUserPassword(requestParameters: OrgResetUserPasswordRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: string | null; }> {
        const response = await this.orgResetUserPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing user with the provided data.  Users can update their own profile with or without an organization context (a user who belongs to no organization sends no X-Organization-ID header). On their own account only the profile fields (username, email, phone, first_name, last_name, grade) may be sent: `password` answers 400 (use POST /auth/change-password, which asks for the current password), and `role_ids` or `is_active` answer 400 (`is_active: false` with \"You cannot deactivate your own account\").  Updating another user requires the X-Organization-ID header of an organization in which the caller is an administrator and the target user is a member; the administrator may change the profile fields, the password and the roles. This endpoint never changes the account status: `is_active` for another user answers 400 (use POST /users/{id}/deactivate or /activate for the membership). Fields outside the schema are ignored.
     * Org Update User
     */
    async orgUpdateUserRaw(requestParameters: OrgUpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserRead>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling orgUpdateUser().'
            );
        }

        if (requestParameters['userUpdate'] == null) {
            throw new runtime.RequiredError(
                'userUpdate',
                'Required parameter "userUpdate" was null or undefined when calling orgUpdateUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xOrganizationID'] != null) {
            headerParameters['X-Organization-ID'] = String(requestParameters['xOrganizationID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/{user_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UserUpdateToJSON(requestParameters['userUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserReadFromJSON(jsonValue));
    }

    /**
     * Update an existing user with the provided data.  Users can update their own profile with or without an organization context (a user who belongs to no organization sends no X-Organization-ID header). On their own account only the profile fields (username, email, phone, first_name, last_name, grade) may be sent: `password` answers 400 (use POST /auth/change-password, which asks for the current password), and `role_ids` or `is_active` answer 400 (`is_active: false` with \"You cannot deactivate your own account\").  Updating another user requires the X-Organization-ID header of an organization in which the caller is an administrator and the target user is a member; the administrator may change the profile fields, the password and the roles. This endpoint never changes the account status: `is_active` for another user answers 400 (use POST /users/{id}/deactivate or /activate for the membership). Fields outside the schema are ignored.
     * Org Update User
     */
    async orgUpdateUser(requestParameters: OrgUpdateUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserRead> {
        const response = await this.orgUpdateUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find active accounts by username or name. Competition organizers and superadmins.  For organizers picking the members of a private user-event team, where any active account may join (#145). Returns id, username, first and last name only, ordered by last name, first name and username, at most `limit` rows; 422 when `search` has fewer than 3 characters after trimming. A lookup, not a listing: there is no paging.
     * Search Users
     */
    async searchUsersRaw(requestParameters: SearchUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserSearchRead>>> {
        if (requestParameters['search'] == null) {
            throw new runtime.RequiredError(
                'search',
                'Required parameter "search" was null or undefined when calling searchUsers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/users/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserSearchReadFromJSON));
    }

    /**
     * Find active accounts by username or name. Competition organizers and superadmins.  For organizers picking the members of a private user-event team, where any active account may join (#145). Returns id, username, first and last name only, ordered by last name, first name and username, at most `limit` rows; 422 when `search` has fewer than 3 characters after trimming. A lookup, not a listing: there is no paging.
     * Search Users
     */
    async searchUsers(requestParameters: SearchUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserSearchRead>> {
        const response = await this.searchUsersRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
